module.exports = "/images/70f6412d0f9da840a7d19877c6b09cf2.svg";